export enum TipoImpresora {
    TICKETERA = 'TICKETERA',
    STICKERS = 'STICKERS',
}
